import React from 'react';
import { getRem } from 'lib/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { BaseInputPrefixSuffix } from './BaseInputPrefixSuffix';
import { INPUT_SIZES, PREFIX_MAX_CHARACTERS_ALLOWED } from '../constants';

const StyledInputPrefix = styled(BaseInputPrefixSuffix)`
  padding-right: ${getRem('2px')};
`;

const InputPrefix = ({ id, isDisabled = false, size = INPUT_SIZES.STANDARD, text, ...other }) => {
  const formattedText = text.substring(0, PREFIX_MAX_CHARACTERS_ALLOWED);

  return (
    <StyledInputPrefix $isDisabled={isDisabled} id={id} {...other}>
      {formattedText}
    </StyledInputPrefix>
  );
};

InputPrefix.propTypes = {
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** Unique identifier. Necessary to have for linking with input */
  id: PropTypes.string.isRequired,
  /** If true, adjusts label styling */
  isDisabled: PropTypes.bool,
  /** Set the size of the input */
  size: PropTypes.oneOf(Object.values(INPUT_SIZES)),
  /** Displays provided text string up to 1 character */
  text: PropTypes.node.isRequired,
};

export { InputPrefix };
